// App screens Admin can switch between Live and Waitlist (Admin → Feature flags → Mobile app screens).
// Stored in Firestore `system/mobileFeatureFlags` as { [id]: 'live' | 'waitlist' }.
// The native app (VRC-Mobile src/config/featureFlags.js) keeps the same ids; its test checks this file.
// `built: false` = the app has no real page yet, so it shows the waitlist whatever the flag says.

export const MOBILE_FLAGS_DOC = ['system', 'mobileFeatureFlags'];
export const MOBILE_LIVE = 'live';
export const MOBILE_WAITLIST = 'waitlist';

export const MOBILE_SCREEN_GROUPS = [
  {
    label: 'Venues',
    screens: [
      { id: 'venues', label: 'Venue Database', built: true },
      { id: 'venue', label: 'Venue page', built: true },
      { id: 'venue-add', label: 'Add Venue', built: true },
      { id: 'venue-grade', label: 'Grade a Venue', built: true },
    ],
  },
  {
    label: 'Community',
    screens: [
      { id: 'community', label: 'Directory', built: true },
      { id: 'friends', label: 'Friends', built: true },
      { id: 'user-profile', label: 'Member profiles', built: true },
      { id: 'gear-swap', label: 'Gear Swap', built: true },
      { id: 'events', label: 'Events', built: true },
      { id: 'community-posts', label: 'Write posts', built: true },
    ],
  },
  {
    label: 'Tour',
    screens: [
      { id: 'calendar', label: 'Calendar', built: true },
      { id: 'map', label: 'Tour Map', built: true },
      { id: 'budget', label: 'Budget', built: true },
    ],
  },
  {
    label: 'Account & money',
    screens: [
      { id: 'wallet', label: 'Wallet', built: true },
      { id: 'profile', label: 'My Profile', built: true },
      { id: 'account', label: 'My Account', built: true },
      { id: 'subscription', label: 'Subscription', built: true },
      { id: 'fund', label: 'Mutual Aid Fund', built: true },
      { id: 'my-files', label: 'My Files', built: true },
      { id: 'my-reports', label: 'My Reports', built: true },
      { id: 'my-credits', label: 'My Credits', built: true },
    ],
  },
  {
    label: 'More',
    screens: [
      { id: 'about', label: 'About', built: true },
      { id: 'contact', label: 'Contact', built: true },
      { id: 'legal', label: 'Legal', built: true },
    ],
  },
];

export const MOBILE_SCREENS = MOBILE_SCREEN_GROUPS.flatMap((g) => g.screens);

/** The stored choice, defaulting like the app does: built → live, not built → waitlist. */
export function mobileFlagValue(flags, screen) {
  const value = flags?.[screen.id];
  if (value === MOBILE_LIVE || value === MOBILE_WAITLIST) return value;
  return screen.built ? MOBILE_LIVE : MOBILE_WAITLIST;
}
